import { styled } from '@linaria/react';

import { colors, fonts, layout, semantic, size, space } from '../../theme/tokens';

export const PageWrapper = styled.section`
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: ${space['space-400']} ${space['space-400']} ${space['space-1200']};
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1000']} ${space['space-1000']} ${space['space-2000']};
  }
`;

export const PageGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${space['space-1000']};
  }
`;

export const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const FormSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const SubLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-300']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ContactMethodRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-300']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ContactMethodCard = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${space['space-400']};
  border: 1px solid
    ${({ $selected }) => ($selected ? semantic.text.primary : semantic.border.subtle)};
  border-radius: ${size.radius['radius-sm']};
  background: ${semantic.bg.canvas};
  transition: border-color 0.15s ease;

  & > label {
    display: flex;
    align-items: center;
    gap: ${space['space-300']};
    width: 100%;
    cursor: pointer;
  }
`;

export const ContactMethodIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.surfaceSubtle};
  color: ${semantic.text.primary};
`;

export const ContactMethodLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const PrivacyLine = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const PrivacyLink = styled.a`
  color: ${semantic.text.primary};
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const SubmitRow = styled.div`
  display: flex;
  flex-direction: column;

  & > button {
    width: 100%;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    justify-content: flex-end;

    & > button {
      width: auto;
    }
  }
`;

export const SubmitFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  align-items: stretch;

  @media (min-width: ${layout.desktopBreakpoint}) {
    align-items: flex-end;
  }
`;
